export const timezones = [
    { "value": "Asia/Calcutta", title: "Asia/Calcutta(IST)" },
    { "value": "America/Anchorage", title: "America/Anchorage(AKST)" },
    { "value": "America/Los_Angeles", title: "America/Los_Angeles(PST)" },
    { "value": "America/Phoenix", title: "America/Phoenix(MST)" },
]